import { render } from "./collection-detail.vue?vue&type=template&id=6ab882dd"
import script from "./collection-detail.vue?vue&type=script&lang=js"
export * from "./collection-detail.vue?vue&type=script&lang=js"

import "./collection-detail.vue?vue&type=style&index=0&id=6ab882dd&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__